// extracted by mini-css-extract-plugin
module.exports = {"Confirmation":"Confirmation__11_Rt","withTopBorder":"withTopBorder__3-Ckj"};